import React from 'react'
import gql from 'graphql-tag'
import {Redirect} from 'react-router'
import {Button, Input} from 'antd'
import {EnvironmentOutlined} from '@ant-design/icons'
import {Mutation} from 'react-apollo'
import {message} from 'antd'

import Query from 'shared/components/Query'
import Layout from 'components/PrivateRoutes/Layout'

export const BookingDeliveryQuery = gql`
  query Booking($id: ID!, $productId: ID!) {
    booking(id: $id) {
      id
      startsAt
      endsAt
      state
      estate {
        id
        invisoRef
        streetAddress
      }
    }

    product(id: $productId) {
      id
      ...on StylingProduct {
        assets {
          edges {
            node {
              id
              ...on TextAsset {
                scope
                text
                updatedAt
              }
            }
          }
        }
      }
    }
  }
`

const addBookingDelivery = gql`
  mutation AddBookingDelivery($input: AddBookingDeliveryInput!) {
    AddBookingDelivery(input: $input) {
      asset {
        id
      }
    }
  }
`

class BookingDeliveryPage extends React.Component {
  state = {
    text: '',
    submitting: false,
  }

  submit(mutation, product) {
    this.setState({submitting: true})

    return mutation({
      variables: {
        input: {
          productId: product.id,
          contentType: 'application/vnd.inviso.text',
          text: this.state.text,
        },
      }
    })
  }

  submitSuccessful = () => {
    message.success('Manus er nå levert til fotograf')
    this.setState({submitting: false, goToBooking: true})
  }

  submitError = () => {
    this.setState({submitting: false})
    message.error('Beklager, noe gikk galt ved leveransen')
  }

  formValid() {
    return true
  }

  deliveryForm({booking, product}) {
    const supplementalAsset = product.assets.edges.find(e => e.node.scope === 'supplemental')

    return (
      <div>
        <div className="inviso-ref">EFKT ref. #{booking.estate.invisoRef}</div>
        <h2 className="deviation-address"><EnvironmentOutlined /> {booking.estate.streetAddress}</h2>

        <Input.TextArea
          placeholder=""
          defaultValue={supplementalAsset ? supplementalAsset.node.text : ''}
          autoSize={{minRows: 5, maxRows: 12}}
          onChange={evt => this.setState({text: evt.target.value})}
        />

        <Mutation
          mutation={addBookingDelivery}
          onCompleted={this.submitSuccessful}
          onError={this.submitError}
        >
          {(addBookingDelivery) => {
            return (
              <Button
                type="primary"
                className="send-deviation-button"
                disabled={!this.formValid() || this.state.submitting}
                onClick={() => this.submit(addBookingDelivery, product)}
              >
                Send manus
              </Button>
            )
          }}
        </Mutation>
      </div>
    )
  }

  render() {
    return (
      <Query
        query={BookingDeliveryQuery}
        variables={this.props.match.params}
        inlineLoading
        inlineError
      >
        {
          ({getData}) => {
            const booking = getData('booking')
            const product = getData('product')

            if (this.state.goToBooking) {
              return <Redirect to={`/bookings/${booking.id}`} />
            }

            if (!booking || !product) {
              return <Redirect to="/bookings" />
            }

            return (
              <Layout
                {...this.props}
                title="Manus til fotograf"
                defaultBackTo="/bookings"
              >
                {this.deliveryForm({booking, product})}
              </Layout>
            )
          }
        }
      </Query>
    )
  }
}

export default BookingDeliveryPage
